<template>
  <div id="app">
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style lang="scss">
@import "assets/scss/app";
</style>



// WEBPACK FOOTER //
// src/App.vue